export const subtractFromNow = (value: number) => {
    return Math.round((Date.now() / 1000 - (value * (24 * 60 * 60))))
}

export const calcDays = (value: number) => {
    return Math.round((Date.now() / 1000 - value) / (24 * 60 * 60))
}
